'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

interface QuestionnaireContextType {
    questionNum: number;
    setQuestionNum: (num: number) => void;
    stepSelectedAnswers: (string[] | string)[];
    setStepSelectedAnswers: (answers: (string[] | string)[]) => void;
    leadId: string;
    setLeadId: (id: string) => void;
}

const CarConditionQuestionnaireContext = createContext<
    QuestionnaireContextType | undefined
>(undefined);

export const CCQuestionnaireProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const [questionNum, setQuestionNum] = useState(0);
    const [stepSelectedAnswers, setStepSelectedAnswers] = useState<
        (string[] | string)[]
    >([]);
    const [leadId, setLeadId] = useState<string>();

    return (
        <CarConditionQuestionnaireContext.Provider
            value={{
                questionNum,
                setQuestionNum,
                stepSelectedAnswers,
                setStepSelectedAnswers,
                leadId,
                setLeadId,
            }}
        >
            {children}
        </CarConditionQuestionnaireContext.Provider>
    );
};

export const useCCQuestionnaire = () => {
    const context = useContext(CarConditionQuestionnaireContext);
    if (!context) {
        throw new Error(
            'useQuestionnaire must be used within a QuestionnaireProvider'
        );
    }
    return context;
};
